import { unauthenticateUser } from './users';

export const handle401 = (dispatch) => {
  return (error) => {
    if (error.is401) return dispatch(unauthenticateUser());
    return Promise.reject(error);
  };
};



// WEBPACK FOOTER //
// ./src/actions/error-handlers.js